import { render, staticRenderFns } from "./StatusTaskModal.vue?vue&type=template&id=55e45b15&scoped=true"
import script from "./StatusTaskModal.vue?vue&type=script&lang=js"
export * from "./StatusTaskModal.vue?vue&type=script&lang=js"
import style0 from "./StatusTaskModal.vue?vue&type=style&index=0&id=55e45b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e45b15",
  null
  
)

export default component.exports